
import {
  SHOP_SET_FILTER,
  SHOP_CLEAR_SEARCH,
} from 'app/common/actions/shop/catalog/filter';

const defaultState = {
  searchString: '',
  loading: true,
};

const filter = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_SET_FILTER: {
      return { ...state, ...payload };
    }
    case SHOP_CLEAR_SEARCH: {
      return { ...state, searchString: '' };
    }

    default:
  }
  return state;
};

export default filter;
